import Api from 'clients/web/Api'
import WebRepository from '../web/WebRepository'
import UserActivity from 'model/UserActivity'

export class UserActivityRepository extends WebRepository<UserActivity> {
  constructor() {
    super(new Api('emr_user_activity'))
  }
}

export default new UserActivityRepository()
